<template>
  <div>
    <div class="row margin-bottom">
      <div class="col-lg-6">
        <p class="lead-header">
          Мы рады нашему сотрудничеству, поэтому разработали Программу Привилегий для наших постоянных клиентов.
        </p>
        <p class="lead-description">
          Сотрудничая с Demis Group, Вы получаете подарки, бонусы и скидки; и чем выше Ваш статус &mdash; тем больше возможностей Вы получаете.
        </p>
        <h2>Правила программы</h2>
        <content-links :data="links" />
      </div>
      <div class="col-lg-6 text-center">
        <img
          class="head-img"
          src="../../../img/privilege-program/rules/bonus-gift-sale.png"
          alt="bonus gift sale"
        >
      </div>
    </div>
    <c-box class="rules">
      <div class="row rules-row">
        <div class="col-lg-2 col-left">
          <img
            src="../../../img/privilege-program/rules/1.png"
            alt="1"
          >
        </div>
        <div class="col-lg-10">
          <a name="terms" />
          <h3>Термины</h3>
          <p><span class="text-bold">1. Старт программы привилегий</span> - дата начала действия программы &laquo;23&raquo; сентября 2014 года.</p>
          <p><span class="text-bold">2. Организатор программы привилегий</span> - АО &laquo;Дэмис Групп&raquo;.</p>
          <p><span class="text-bold">3. Программы привилегий Demis Group</span> - комплекс взаимосвязанных действий и мероприятий, предоставляющих Участникам возможность в случае долговременного сотрудничества с Организатором Программы получать различные привилегии, бесплатные услуги, скидки и спецпредложения.</p>
          <p><span class="text-bold">4. Статус участника</span> - статус, отражающий долговременность сотрудничества Участника, сумму ежемесячной платы Участника по абонентским услугам АО &laquo;Дэмис Групп&raquo;, а также уровень доступных Участнику привилегий. В Программе Привилегий существует четыре статуса (в порядке от низшего к высшему):</p>
          <div class="statuses">
            <div>
              <img
                src="../../../img/status_bronze.png"
                alt="Bronze"
              > <span class="status-name">Bronze</span>
            </div>
            <div>
              <img
                src="../../../img/status_silver.png"
                alt="Silver"
              > <span class="status-name">Silver</span>
            </div>
            <div>
              <img
                src="../../../img/status_gold.png"
                alt="Gold"
              > <span class="status-name">Gold</span>
            </div>
            <div>
              <img
                src="../../../img/status_platinum.png"
                alt="Platinum"
              > <span class="status-name">Platinum</span>
            </div>
          </div>
          <div class="clearfix" />
          <p>
            <span class="text-bold">5.</span> Такие привилегии, как «Написание и размещение пресс-релиза» и «Бесплатные часы технической поддержки сайта», необходимо активировать в Личном Кабинете. <span class="text-bold">В состав «Бесплатные часы технической поддержки сайта» входит</span>:<br>
            • Наполнение каталога в объёме ЧЛ<br>
            • Размещение отзывов/новостей в объёме ЧЛ<br>
            • Размещение контента в объёме ЧЛ<br>
            • Вёрстка элементов сайта в объёме ЧЛ<br>
            • Настройка HTTPS<br>
            • Обновление 1C Bitrix с версии 20+ до актуальной.<br>
          </p>
        </div>
        <div class="col-lg-12">
          <div class="row rules-row">
            <div class="col-lg-2 col-left">
              <img
                src="../../../img/privilege-program/rules/2.png"
                alt="2"
              >
            </div>
            <div class="col-lg-10">
              <a name="advantages" />
              <h3>Преимущества статусов участников</h3>

              <div class="accordeon">
                <a
                  role="button"
                  data-toggle="collapse"
                  href="#collapse-bronze"
                  aria-expanded="true"
                  aria-controls="collapse-bronze"
                >
                  <i class="fa fa-chevron-up" />
                  <i class="fa fa-chevron-down" />
                  <img
                    src="../../../img/status_bronze.png"
                    alt="Bronze"
                  > <span class="status-name">Bronze</span>
                </a>
                <div
                  id="collapse-bronze"
                  class="collapse in"
                >
                  <p>
                    <span class="text-bold">1. Скидка 5% на подключение новой услуги, оказываемой АО «Дэмис Групп».</span><br>
                    • Данная скидка предоставляется на 1 (первый) месяц работы по новой услуге.
                  </p>
                  <p>
                    <span class="text-bold">2. Скидка 3% ежемесячно на продвижение второго и последующих сайтов Участника.</span><br>
                    • Данная скидка предоставляется на все время сотрудничества, пока в работе у Организатора Программы Привилегий находятся не менее 2 сайтов Участника. Если в работе у Организатора остался только 1 сайт, скидка аннулируются. В расчет берутся только те сайты, которые были подключены после старта Программы Привилегий.
                  </p>
                  <p>
                    <span class="text-bold">3. Скидка на продвижение сайта Участника за рекомендацию АО «Дэмис Групп» третьим лицам.</span><br>
                    В случае обращения в АО «Дэмис Групп» третьих лиц по рекомендации Участника и последующего подписания с ними договора и оплаты услуг по продвижению сайта, Участнику предоставляется скидка на продвижение сайта по текущему договору сроком на 3 месяца. В расчет берутся только те сайты, которые были подключены после старта Программы Привилегий.<br>
                    Расчет скидки ведется исходя из 3% от стоимости оказанных третьему лицу услуг продвижения сайта за предыдущий период.<br>
                    В случае прекращения сотрудничества с третьими лицами скидка Участнику не предоставляется.
                  </p>
                  <p>
                    <span class="text-bold">4. Бесплатная доставка корреспонденции Почтой России:</span><br>
                    • не подлежит передаче третьим лицам, не может быть обременена, заложена, уступлена третьим лицам.
                  </p>
                  <p>
                    <span class="text-bold">5. Письмо-поздравление с Днем Рождения Компании.</span><br>
                    Условия предоставления и использования права на Письмо-поздравление с Днем Рождения Компании - Участника:<br>
                    • Письмо-поздравление отправляется не чаще 1 (одного) раза в течение 12 (двенадцати) месяцев;<br>
                    • В случае, если Участник укажет в своем Личном Кабинете дату Дня Рождения Компании менее, чем за 6 (шесть) дней до Дня Рождения Компании включительно, Организатор Программы Привилегий не сможет обеспечить данную привилегию.
                  </p>
                  <p>
                    <span class="text-bold">6. Получение ежемесячного отчета:</span><br>
                    • Один раз в месяц Участник получает отчет о проделанных работах и достигнутых результатах за предыдущий период.
                  </p>
                  <p>
                    <span class="text-bold">7. Возможность обращения в Online Службу Качества посредством Личного кабинета.</span><br>
                    • В любое время неограниченное количество раз Участник может обратиться в Online Службу Качества Организатора Программы Привилегий для получения ответов на нерешенные в стандартном порядке вопросы.
                  </p>
                </div>

                <a
                  role="button"
                  data-toggle="collapse"
                  href="#collapse-silver"
                  aria-expanded="false"
                  aria-controls="collapse-silver"
                >
                  <i class="fa fa-chevron-up" />
                  <i class="fa fa-chevron-down" />
                  <img
                    src="../../../img/status_silver.png"
                    alt="Bronze"
                  > <span class="status-name">Silver</span>
                </a>
                <div
                  id="collapse-silver"
                  class="collapse"
                >
                  <p>
                    <span class="text-bold">1. Скидка 10% на подключение новой услуги, оказываемой АО «Дэмис Групп».</span><br>
                    • Данная скидка предоставляется на 1 (первый) месяц работы по новой услуге.
                  </p>
                  <p>
                    <span class="text-bold">2. Скидка 5% ежемесячно на продвижение второго и последующих сайтов Участника.</span><br>
                    • Данная скидка предоставляется на все время сотрудничества, пока в работе у Организатора Программы Привилегий находятся не менее 2 сайтов Участника. Если в работе у Организатора остался только 1 сайт, скидка аннулируются. В расчет берутся только те сайты, которые были подключены после старта Программы Привилегий.
                  </p>
                  <p>
                    <span class="text-bold">3. Скидка на продвижение сайта Участника за рекомендацию АО «Дэмис Групп» третьим лицам.</span><br>
                    • В случае обращения в АО «Дэмис Групп» третьих лиц по рекомендации Участника и последующего подписания с ними договора и оплаты услуг по продвижению сайта, Участнику предоставляется скидка на продвижение сайта по текущему договору сроком на 3 месяца. В расчет берутся только те сайты, которые были подключены после старта Программы Привилегий.
                    • Расчет скидки ведется исходя из 5% от стоимости оказанных третьему лицу услуг продвижения сайта за предыдущий период.
                    • В случае прекращения сотрудничества с третьими лицами скидка Участнику не предоставляется.
                  </p>
                  <p>
                    <span class="text-bold">4. Бесплатная доставка корреспонденции Почтой России:</span><br>
                    • Бесплатная доставка не подлежит передаче третьим лицам, не может быть обременена, заложена, уступлена третьим лицам.
                  </p>
                  <p>
                    <span class="text-bold">5. Письмо-поздравление с Днем Рождения Компании.</span><br>
                    Условия предоставления и использования права на Письмо-поздравление с Днем Рождения Компании - Участника:<br>
                    • Письмо-поздравление отправляется не чаще 1 (одного) раза в течение 12 (двенадцати) месяцев;
                    • В случае, если Участник укажет в своем Личном Кабинете дату Дня Рождения Компании менее, чем за 6 (шесть) дней до Дня Рождения Компании включительно, Организатор Программы Привилегий не сможет обеспечить данную привилегию.
                  </p>
                  <p>
                    <span class="text-bold">6. Получение ежемесячного отчета:</span><br>
                    • Один раз в месяц Участник получает отчет о проделанных работах и достигнутых результатах за предыдущий период.
                  </p>
                  <p>
                    <span class="text-bold">7. Возможность обращения в Online Службу Качества посредством Личного кабинета.</span><br>
                    • В любое время неограниченное количество раз Участник может обратиться в Online Службу Качества Организатора Программы Привилегий для получения ответов на нерешенные в стандартном порядке вопросы.
                  </p>
                  <p>
                    <span class="text-bold">8. Бесплатное размещение пресс-релиза «О компании» на целевых площадках:</span><br>
                    • может быть реализовано не чаще 1 раза в квартал;
                    • предоставляет возможность получения бесплатного написания 1 (одного) пресс-релиза и размещения его на 40 различных целевых площадках в Интернете.
                    • чтобы воспользоваться бесплатным размещением пресс-релиза, необходимо активизировать услугу в Личном кабинете и передать Организатору файл с описанием информационного повода для написания пресс-релиза.
                  </p>
                </div>

                <a
                  role="button"
                  data-toggle="collapse"
                  href="#collapse-gold"
                  aria-expanded="false"
                  aria-controls="collapse-gold"
                >
                  <i class="fa fa-chevron-up" />
                  <i class="fa fa-chevron-down" />
                  <img
                    src="../../../img/status_gold.png"
                    alt="Gold"
                  > <span class="status-name">Gold</span>
                </a>
                <div
                  id="collapse-gold"
                  class="collapse"
                >
                  <p>
                    <span class="text-bold">1. Скидка 20% на подключение новой услуги, оказываемой АО «Дэмис Групп».</span><br>
                    • Данная скидка предоставляется на 1 (первый) месяц работы по новой услуге.
                  </p>
                  <p>
                    <span class="text-bold">2. Скидка 7% ежемесячно на продвижение второго и последующих сайтов Участника.</span><br>
                    • Данная скидка предоставляется на все время сотрудничества, пока в работе у Организатора Программы Привилегий находятся не менее 2 сайтов Участника. Если в работе у Организатора остался только 1 сайт, скидка аннулируются. В расчет берутся только те сайты, которые были подключены после старта Программы Привилегий.
                  </p>
                  <p>
                    <span class="text-bold">3. Скидка на продвижение сайта Участника за рекомендацию АО «Дэмис Групп» третьим Лицам.</span><br>
                    • В случае обращения в АО «Дэмис Групп» третьих лиц по рекомендации Участника и последующего подписания с ними договора и оплаты услуг по продвижению сайта, Участнику предоставляется скидка на продвижение сайта по текущему договору сроком на 3 месяца. В расчет берутся только те сайты, которые были подключены после старта Программы Привилегий.
                    • Расчет скидки ведется исходя из 7% от стоимости оказанных третьему лицу услуг продвижения сайта за предыдущий период.
                    • В случае прекращения сотрудничества с третьими лицами скидка Участнику не предоставляется.
                  </p>
                  <p>
                    <span class="text-bold">4. Быстрая доставка документов курьерской службой:</span><br>
                    • Возможность быстрой доставки документов курьерской службой не подлежит передаче третьим лицам, не может быть обременена, заложена, уступлена третьим лицам.
                  </p>
                  <p>
                    <span class="text-bold">5. Письмо-поздравление с Днем Рождения Компании.</span><br>
                    Условия предоставления и использования права на подарок и Письмо-поздравление с Днем Рождения Компании – Участника:<br>
                    • Подарок и Письмо-поздравление отправляется не чаще 1 (одного) раза в течение 12 (двенадцати) месяцев;
                    • В случае, если Участник укажет в своем Личном Кабинете дату Дня Рождения Компании менее, чем за 6 (шесть) дней до Дня Рождения Компании включительно, Организатор Программы Привилегий не сможет обеспечить данную привилегию.
                  </p>
                  <p>
                    <span class="text-bold">6. Получение ежемесячного отчета и расширенного отчета по проекту с анализом динамики развития за квартал и полугодие:</span><br>
                    • Один раз в месяц Участник получает отчет о проделанных работах и достигнутых результатах за предыдущий период, а также расширенный отчет с анализом динамики развития за квартал и полугодие.
                  </p>
                  <p>
                    <span class="text-bold">7. Возможность обращения в Online Службу Качества посредством Личного кабинета.</span><br>
                    • В любое время неограниченное количество раз Участник может обратиться в Online Службу Качества Организатора Программы Привилегий для получения ответов на нерешенные в стандартном порядке вопросы.
                  </p>
                  <p>
                    <span class="text-bold">8. Бесплатное размещение пресс-релиза «О компании» на целевых площадках:</span><br>
                    • может быть реализовано не чаще 1 раза в 2 месяца;
                    • предоставляет возможность получения бесплатного написания 1 (одного) пресс-релиза и размещения его на 40 различных целевых площадках в Интернете.
                    • Чтобы воспользоваться бесплатным размещением пресс-релиза, необходимо активизировать услугу в Личном кабинете и передать Организатору файл с описанием информационного повода для написания пресс-релиза.
                  </p>
                  <p><span class="text-bold">9. Бесплатная настройка целей в счетчиках статистики.</span></p>
                  <p>
                    <span class="text-bold">10. Бесплатное наращивание естественных ссылок:</span><br>
                    • может быть реализовано не чаще 1 раза в 3 месяца;
                    • предоставляет возможность бесплатного получения дополнительных качественных ссылок в 3 геосервисах, в 3 справочниках компаний, на 3 форумах и на 30 досках объявлений.
                  </p>
                  <p>
                    <span class="text-bold">11. Бесплатные работы по Технической поддержке сайта:</span><br>
                    • возможность бесплатного обновления и развития сайта;
                    • может быть реализовано не чаще 1 раза в 3 месяца с лимитом времени не более 3 часов за один раз.
                    • Чтобы воспользоваться этим преимуществом, необходимо активизировать услугу в Личном кабинете и передать Организатору файл с описанием необходимых изменений сайта.
                  </p>
                  <p>
                    <span class="text-bold">12. Полная комплексная юзабилити-проработка Вашего сайта.</span><br>
                    • позволит Вам полностью оптимизировать сайт, сделав его максимально простым и удобным для пользователей.
                    • включает в себя проведение анализа юзабилити сайта, подготовку рекомендаций, разработку макетов и прототипов страниц сайта, внесение Организатором изменений на Сайт в соответствии с разработанными рекомендациями, проведение тестирования изменений и контроль результатов, в случае необходимости внесение дополнительных изменений.
                    • бонус предоставляется не ранее 3 (третьего) месяца с начала работ по проекту. Точное время начала предоставления бонуса определяется Организатором исходя из потребности, выявленной в результате работы с сайтом.
                  </p>
                </div>

                <a
                  role="button"
                  data-toggle="collapse"
                  href="#collapse-platinum"
                  aria-expanded="false"
                  aria-controls="collapse-platinum"
                >
                  <i class="fa fa-chevron-up" />
                  <i class="fa fa-chevron-down" />
                  <img
                    src="../../../img/status_platinum.png"
                    alt="Platinum"
                  > <span class="status-name">Platinum</span>
                </a>
                <div
                  id="collapse-platinum"
                  class="collapse"
                >
                  <p>
                    <span class="text-bold">1. Скидка 25% на подключение новой услуги, оказываемой АО «Дэмис Групп».</span><br>
                    • Данная скидка предоставляется на 1 (первый) месяц работы по новой услуге.
                  </p>
                  <p>
                    <span class="text-bold">2. Скидка 10% ежемесячно на продвижение второго и последующих сайтов Участника.</span><br>
                    • Данная скидка предоставляется на все время сотрудничества, пока в работе у Организатора Программы Привилегий находятся не менее 2 сайтов Участника. Если в работе у Организатора остался только 1 сайт, скидка аннулируются. В расчет берутся только те сайты, которые были подключены после старта Программы Привилегий.
                  </p>
                  <p>
                    <span class="text-bold">3. Скидка на продвижение сайта Участника за рекомендацию АО «Дэмис Групп» третьим Лицам.</span><br>
                    • В случае обращения в АО «Дэмис Групп» третьих лиц по рекомендации Участника и последующего подписания с ними договора и оплаты услуг по продвижению сайта, Участнику предоставляется скидка на продвижение сайта по текущему договору сроком на 3 месяца. В расчет берутся только те сайты, которые были подключены после старта Программы Привилегий.
                    • Расчет скидки ведется исходя из 10% от стоимости оказанных третьему лицу услуг продвижения сайта за предыдущий период.
                    • В случае прекращения сотрудничества с третьими лицами скидка Участнику не предоставляется.
                  </p>
                  <p>
                    <span class="text-bold">4. Быстрая доставка документов курьерской службой:</span><br>
                    • Быстрая доставка документов курьерской службой не подлежит передаче третьим лицам, не может быть обременена, заложена, уступлена третьим лицам.
                  </p>
                  <p>
                    <span class="text-bold">5. Письмо-поздравление с Днем Рождения Компании.</span><br>
                    Условия предоставления и использования права на подарок и Письмо-поздравление с Днем Рождения Компании – Участника:<br>
                    • Подарок и Письмо-поздравление отправляется не чаще 1 (одного) раза в течение 12 (двенадцати) месяцев;
                    • В случае, если Участник укажет в своем Личном Кабинете дату Дня Рождения Компании менее, чем за 6 (шесть) дней до Дня Рождения Компании включительно, Организатор Программы Привилегий не сможет обеспечить данную привилегию.
                  </p>
                  <p>
                    <span class="text-bold">6. Получение ежемесячного отчета и расширенного отчета по проекту с анализом динамики развития за квартал и полугодие:</span><br>
                    • Один раз в месяц Участник получает отчет о проделанных работах и достигнутых результатах за предыдущий период, а также расширенный отчет с анализом динамики развития за квартал и полугодие.
                  </p>
                  <p>
                    <span class="text-bold">7. Возможность обращения в Online Службу Качества посредством Личного кабинета.</span><br>
                    • В любое время неограниченное количество раз Участник может обратиться в Online Службу Качества Организатора Программы Привилегий для получения ответов на нерешенные в стандартном порядке вопросы.
                  </p>
                  <p>
                    <span class="text-bold">8. Бесплатное размещение пресс-релиза «О компании» на целевых площадках:</span><br>
                    • может быть реализовано не чаще 1 раза в месяц;
                    • предоставляет возможность получения бесплатного написания 1 (одного) пресс-релиза и размещения его на 40 различных целевых площадках в Интернете.
                    • Чтобы воспользоваться бесплатным размещением пресс-релиза, необходимо активизировать услугу в Личном кабинете и передать Организатору файл с описанием информационного повода для написания пресс-релиза.
                  </p>
                  <p><span class="text-bold">9. Бесплатная настройка целей в счетчиках статистики.</span></p>
                  <p>
                    <span class="text-bold">10. Бесплатное наращивание естественных ссылок:</span><br>
                    • может быть реализовано не чаще 1 раза в 3 месяца;
                    • предоставляет возможность бесплатного получения дополнительных качественных ссылок в 3 геосервисах, в 5 справочниках компаний, на 5 форумах и на 50 досках объявлений.
                  </p>
                  <p>
                    <span class="text-bold">11. Бесплатные работы по Технической поддержке сайта:</span><br>
                    • возможность бесплатного обновления и развития сайта;
                    • могут быть реализованы не чаще 1 раза в 3 месяца с лимитом времени не более 5 часов за один раз.
                    • Чтобы воспользоваться данным преимуществом, необходимо активизировать услугу в Личном кабинете и передать Организатору файл с описанием необходимых изменений сайта.
                  </p>
                  <p>
                    <span class="text-bold">12. Полная комплексная юзабилити-проработка Вашего сайта.</span><br>
                    • позволит Вам полностью оптимизировать сайт, сделав его максимально простым и удобным для пользователей.
                    • включает в себя проведение анализа юзабилити сайта, подготовку рекомендаций, разработку макетов и прототипов страниц сайта, внесение Организатором изменений на Сайт в соответствии с разработанными рекомендациями, проведение тестирования изменений и контроль результатов, в случае необходимости внесение дополнительных изменений.
                    • бонус предоставляется не ранее 3 (третьего) месяца с начала работ по проекту. Точное время начала предоставления бонуса определяется Организатором исходя из потребности, выявленной в результате работы с сайтом.
                  </p>
                  <p>
                    <span class="text-bold">13. Бесплатная рассылка Вашей рекламной листовки всем ключевым Клиентам Demis Group.</span><br>
                    • может быть реализована не чаще 1 раза в 6 месяцев.
                    • Тираж не более 2 000 штук.
                    • Чтобы воспользоваться данным бонусом, необходимо активизировать услугу в Личном кабинете и передать рекламные листовки Организатору.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row rules-row">
            <div class="col-lg-2 col-left">
              <img
                src="../../../img/privilege-program/rules/3.png"
                alt="3"
              >
            </div>
            <div class="col-lg-10">
              <a name="status-change" />
              <h3>Присвоение, изменение, утрата статуса</h3>

              <p class="text-bold">
                1. Статус присваивается Участнику после первой оплаты по договору на продвижение сайта одновременно с регистрацией его в Личном кабинете.
              </p>
              <p class="text-bold">
                2. Статус Участника изменяется в случае достижения Участником показателей, удовлетворяющих приведенным ниже условиям присвоения соответствующего Статуса:
              </p>
              <div class="row statuses-extended">
                <div class="col-md-6 col-lg-3">
                  <div class="status">
                    <img
                      src="../../../img/status_bronze.png"
                      alt="Bronze"
                    >
                    <p class="status-name">
                      Bronze
                    </p>
                    <p>
                      Ежемесячный бюджет:<br>
                      до 40 000 рублей.
                    </p>
                  </div>
                </div>
                <div class="col-md-6 col-lg-3">
                  <div class="status">
                    <img
                      src="../../../img/status_silver.png"
                      alt="Silver"
                    >
                    <p class="status-name">
                      Silver
                    </p>
                    <p>
                      Ежемесячный бюджет:<br>
                      до 40 000 - 80 000 рублей.
                    </p>
                    <p class="text-bold">
                      Сотрудничество от 4 месяцев.
                    </p>
                  </div>
                </div>
                <div class="col-md-6 col-lg-3">
                  <div class="status">
                    <img
                      src="../../../img/status_gold.png"
                      alt="Gold"
                    >
                    <p class="status-name">
                      Gold
                    </p>
                    <p>
                      Ежемесячный бюджет:<br>
                      до 80 000 - 120 000 рублей.
                    </p>
                    <p class="text-bold">
                      Сотрудничество от 8 месяцев.
                    </p>
                  </div>
                </div>
                <div class="col-md-6 col-lg-3">
                  <div class="status">
                    <img
                      src="../../../img/status_platinum.png"
                      alt="Platinum"
                    >
                    <p class="status-name">
                      Platinum
                    </p>
                    <p>
                      Ежемесячный бюджет:<br>
                      от 120 000 рублей.
                    </p>
                    <p class="text-bold">
                      Сотрудничество от 12 месяцев.
                    </p>
                  </div>
                </div>
              </div>
              <p>Также при условии сотрудничества сроком более 3 (трех) лет Участнику присваивается статус Gold, а более 4 (четырех) лет – статус Platinum вне зависимости от суммы ежемесячной платы Участника.</p>

              <p>
                <span class="text-bold">3. На присвоение Статуса Участника влияет одновременное соблюдение требований по следующим показателям:</span><br>
                - подключена услуга продвижения сайта (SEO);<br>
                - сумма ежемесячной платы Участника по абонентским услугам АО «Дэмис Групп»;<br>
                - период сотрудничества Участника с Организатором Программы Привилегий.
              </p>
              <p>
                <span class="text-bold">4. Если выполняется только одно требование, статус не изменяется.</span><br>
                Исключением являются следующие случаи:<br>
                - переход Участника из Статуса Bronzе в Статус Silver при наличии у Участника 3 (трех) и более подключенных абонентских услуг;<br>
                - переход Участника из Статуса Bronzе в Статус Silver при сумме ежемесячной платы по абонентским услугам АО «Дэмис Групп» более 200 000 рублей вне зависимости от периода сотрудничества.
              </p>
              <p><span class="text-bold">5. В момент Старта Программы Привилегий статусы присваиваются Участникам автоматически</span>, исходя из соблюдения на момент Старта требований, указанных в пункте 3.3.</p>
              <p><span class="text-bold">6. В случае прерывания сотрудничества Участника и Организатора Программы Привилегий сроком более чем на 1 месяц</span>, период сотрудничества начинает отсчитываться с нуля, а статус автоматически меняется на соответствующий новому периоду сотрудничества.</p>
            </div>
          </div>
          <div class="row rules-row">
            <div class="col-lg-2 col-left">
              <img
                src="../../../img/privilege-program/rules/4.png"
                alt="4"
              >
            </div>
            <div class="col-lg-10">
              <a name="status-upgrade" />
              <h3>Способы повышения статуса</h3>

              <p class="text-bold">
                1. Участник может повысить Статус за счет продолжительного период сотрудничества с Организатором Программы Привилегий.
              </p>
              <p><span class="text-bold">2. Если сумма ежемесячной платы по абонентским услугам достаточна для повышения Статуса, а период сотрудничества недостаточен, Участник может повысить Статус за счет внесения предоплаты за необходимое количество месяцев вперед</span>. Необходимо оплатить ровно столько месяцев, сколько не хватает до нового Статуса.</p>
              <p><span class="text-bold">3. Если сумма ежемесячной платы по абонентским услугам недостаточна для повышения Статуса, а период сотрудничества достаточен, Участник может повысить Статус за счет подключения новой услуги, предполагающей абонентскую плату, при продолжении сотрудничества по текущей услуге (SEO,ТП, SERM и др.)</span>. Необходимо подключить новую услугу, абонентская плата за которую больше или равна недостающей до следующего Статуса сумме. Участник также может повысить Статус за счет увеличения ежемесячной абонентской платы по текущей услуге (Расширение количества запросов, по которым продвигается сайт, добавление новых регионов продвижения и др.).</p>
              <p class="text-bold">
                4. Для перехода из статуса Bronze в статус Silver Участник может подключить новые услуги до общего числа подключенных услуг, равного 3 (трем).
              </p>
            </div>
          </div>
          <div class="row rules-row">
            <div class="col-lg-2 col-left">
              <img
                src="../../../img/privilege-program/rules/5.png"
                alt="5"
              >
            </div>
            <div class="col-lg-10">
              <a name="newsletter" />
              <h3>Получение рассылок</h3>

              <p class="text-bold">
                1. Все уведомления, сообщения, предусмотренные настоящим Регламентом, направляются на адрес электронной почты, указанный Участником.
              </p>
            </div>
          </div>
          <div class="row rules-row">
            <div class="col-lg-2 col-left">
              <img
                src="../../../img/privilege-program/rules/6.png"
                alt="6"
              >
            </div>
            <div class="col-lg-10">
              <a name="other" />
              <h3>Прочие условия</h3>

              <p class="text-bold">
                1. Настоящий Регламент вступает в силу с даты Старта Программы Привилегий и действует в течение срока дополнительно устанавливаемого Организатором.
              </p>
              <p class="text-bold">
                2. Организатор Программы Привилегий вправе без предварительного уведомления лишить Участника Статуса Участника и/или права участия в Программы Привилегий в случае наличия у Организатора оснований квалифицировать действия Участника как злоупотребление.
              </p>
              <p class="text-bold">
                3. Организатор вправе в любое время в одностороннем порядке внести изменения в настоящий Регламент без предварительного уведомления Участников. Участник вправе ознакомиться с актуальной версией Регламента на странице Личного кабинета.
              </p>
              <p class="text-bold">
                4. Организатор оставляет за собой право отменить Программу Привилегий без предварительного уведомления Участника.
              </p>
              <p class="text-bold">
                5. Обновление статусов производится ежедневно.
              </p>
            </div>
          </div>
        </div>
      </div>
    </c-box>
  </div>
</template>

<script>
import CBox from '../../components/ui/CBox'
import ContentLinks from '../../components/ContentLinks.vue'

export default {
  name: 'Rules',
  components: {
    ContentLinks,
    CBox
  },
  data () {
    return {
      links: [
        {
          href: 'terms',
          title: 'Термины'
        },
        {
          href: 'advantages',
          title: 'Преимущества статусов участников'
        },
        {
          href: 'status-change',
          title: 'Присвоение, изменение, утрата статуса'
        },
        {
          href: 'status-upgrade',
          title: 'Способы повышения статуса'
        },
        {
          href: 'newsletter',
          title: 'Получение рассылок'
        },
        {
          href: 'other',
          title: 'Прочие условия'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.lead-header {
  font-size: 2.5em;
}

.lead-description {
  font-size: 1.5em;
}

.statuses {
  & > div {
    float: left;
    margin-bottom: 15px;
    height: 36px;

    @media (max-width: $xsBreakpoint) {
      float: none;
    }
  }

  img {
    margin-left: 30px;

    @media (max-width: $xsBreakpoint) {
      margin-left: 15px;
    }
  }
}

.rules {
  .rules-row {
    border-bottom: 1px solid lightgray;
    padding: 30px 0;

    &:last-child {
      border: none;
    }

    .col-left {
      text-align: center;

      img {
        width: 100%;

        @media (max-width: $mdBreakpoint) {
          width: initial;
          max-width: 100%;
          padding: 15px 0;
        }
      }
    }
  }

  h3 {
    margin-top: 0;
    text-transform: uppercase;
  }
}

.accordeon {
  a[data-toggle="collapse"] {
    display: block;
    padding: 15px;
    background-color: #fdf3f4;
    text-decoration: none;
  }

  a[data-toggle="collapse"] .fa {
    display: none;
    margin-right: 10px;
  }

  a[aria-expanded="true"] .fa.fa-chevron-up {
    display: inline-block;
  }

  a[aria-expanded="false"] .fa.fa-chevron-down {
    display: inline-block;
  }

  a[data-toggle="collapse"] {
    margin-bottom: 15px;
  }
}

.statuses-extended {
  display: flex;

  @media (max-width: $mdBreakpoint) {
    display: block;
  }

  & > div {
    padding: 15px;
  }

  .status {
    height: 100%;
    padding: 15px;
    border: 1px dashed lightgray;
    border-radius: $borderRadiusLarge;

    img {
      margin-bottom: 15px;
    }
  }
}

.status-name {
  font-size: 1.2em;
  font-weight: bold;
}

.head-img {
  max-width: 100%;
}
</style>
